import React from 'react'

import Script from 'dangerous-html/react'
import { Helmet } from 'react-helmet'

import Navigation from '../components/navigation'
import Footer from '../components/footer'
import './vendor-risk-management.css'

const VendorRiskManagement = (props) => {
  return (
    <div className="vendor-risk-management-container1">
      <Helmet>
        <title>Cysigil Network Pvt Ltd</title>
        <meta
          property="og:title"
          content="Vendor-Risk-Management - Well Off Notable Fish"
        />
        <link
          rel="canonical"
          href="https://well-off-notable-fish-gmgkwg.teleporthq.app/vendor-risk-management"
        />
      </Helmet>
      <Navigation></Navigation>
      <section className="hero-vrm">
        <div className="hero-vrm__media">
          <img
            alt="Cybersecurity expert inspecting lines of code on multiple monitors in a dimly lit office"
            src="https://images.pexels.com/photos/6963098/pexels-photo-6963098.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
            className="hero-vrm__image"
          />
        </div>
        <div className="hero-vrm__overlay"></div>
        <div className="hero-vrm__content">
          <div className="hero-vrm__content-inner">
            <div className="hero-vrm__icon-wrapper">
              <svg
                width="48"
                xmlns="http://www.w3.org/2000/svg"
                height="48"
                viewBox="0 0 24 24"
                className="hero-vrm__icon"
              >
                <path
                  d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                ></path>
              </svg>
            </div>
            <h1 className="hero-title hero-vrm__title">
              Vendor Risk Management
            </h1>
            <p className="hero-vrm__subtitle hero-subtitle">
              Comprehensive third-party risk assessments, due diligence, and
              continuous monitoring to secure your vendor ecosystem and protect
              your enterprise from supply chain vulnerabilities.
            </p>
            <div className="hero-vrm__actions">
              <a className="btn-primary btn btn-lg" href="https://outlook.office.com/book/CysigilNetwork@cysigil.com/?ismsaljsauthenabled">
                <span>Talk to an Expert</span>
              </a>
              <a href="/contact-us">
                <div className="btn btn-lg btn-outline">
                  <span style={{ color: 'black' }}>Request Assessment</span>
                </div>
              </a>
            </div>
          </div>
        </div>
      </section>
      <section className="features-vrm">
        <div className="features-vrm__container">
          <div className="features-vrm__header">
            <h2 className="features-vrm__section-title section-title">
              What is Vendor Risk Management?
            </h2>
            <p className="features-vrm__section-subtitle section-subtitle">
              A comprehensive program designed to identify, assess, and mitigate
              risks associated with third-party vendors, suppliers, and service
              providers throughout their entire lifecycle.
            </p>
          </div>
          <div className="features-vrm__grid">
            <div className="features-vrm__card">
              <div className="features-vrm__card-icon">
                <svg
                  width="40"
                  xmlns="http://www.w3.org/2000/svg"
                  height="40"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <circle r="10" cx="12" cy="12"></circle>
                    <circle r="6" cx="12" cy="12"></circle>
                    <circle r="2" cx="12" cy="12"></circle>
                  </g>
                </svg>
              </div>
              <h3 className="features-vrm__card-title">Program Scope</h3>
              <p className="section-content features-vrm__card-description">
                Define and establish a structured vendor risk program covering
                all third parties, from software providers to hardware
                suppliers, with clear ownership and accountability frameworks.
              </p>
            </div>
            <div className="features-vrm__card">
              <div className="features-vrm__card-icon">
                <svg
                  width="40"
                  xmlns="http://www.w3.org/2000/svg"
                  height="40"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M2.062 12.348a1 1 0 0 1 0-.696a10.75 10.75 0 0 1 19.876 0a1 1 0 0 1 0 .696a10.75 10.75 0 0 1-19.876 0"></path>
                    <circle r="3" cx="12" cy="12"></circle>
                  </g>
                </svg>
              </div>
              <h3 className="features-vrm__card-title">Assessment Gates</h3>
              <p className="section-content features-vrm__card-description">
                Multi-stage evaluation checkpoints at onboarding, during
                contract renewal, and following significant changes to ensure
                continuous vendor compliance and risk awareness.
              </p>
            </div>
            <div className="features-vrm__card">
              <div className="features-vrm__card-icon">
                <svg
                  width="40"
                  xmlns="http://www.w3.org/2000/svg"
                  height="40"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"></path>
                    <path d="m9 12l2 2l4-4"></path>
                  </g>
                </svg>
              </div>
              <h3 className="features-vrm__card-title">Risk Methodology</h3>
              <p className="section-content features-vrm__card-description">
                Proven frameworks aligned with industry standards, leveraging
                quantitative scoring, qualitative analysis, and threat
                intelligence to produce actionable risk profiles.
              </p>
            </div>
          </div>
        </div>
      </section>
      <section className="process-vrm-one">
        <div className="process-vrm-one__container">
          <div className="process-vrm-one__header">
            <h2 className="process-vrm-one__section-title section-title">
              Vendor Risk Assessment Process
            </h2>
            <p className="section-subtitle process-vrm-one__section-subtitle">
              A structured, three-phase approach to systematically evaluate
              third-party security, compliance, and operational risks.
            </p>
          </div>
          <div className="process-vrm-one__steps">
            <div className="process-vrm-one__step">
              <div className="process-vrm-one__step-number">
                <span>01</span>
              </div>
              <div className="process-vrm-one__step-icon">
                <svg
                  width="32"
                  xmlns="http://www.w3.org/2000/svg"
                  height="32"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <circle r="8" cx="11" cy="11"></circle>
                    <path d="m21 21l-4.3-4.3M11 7v4m0 4h.01"></path>
                  </g>
                </svg>
              </div>
              <h3 className="process-vrm-one__step-title">Risk Assessment</h3>
              <p className="section-content process-vrm-one__step-description">
                Conduct initial risk classification based on vendor criticality,
                data access level, and business impact. Categorize vendors into
                risk tiers for tailored assessment depth.
              </p>
            </div>
            <div className="process-vrm-one__step">
              <div className="process-vrm-one__step-number">
                <span>02</span>
              </div>
              <div className="process-vrm-one__step-icon">
                <svg
                  width="32"
                  xmlns="http://www.w3.org/2000/svg"
                  height="32"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
              </div>
              <h3 className="process-vrm-one__step-title">
                Due Diligence Questionnaires
              </h3>
              <p className="section-content process-vrm-one__step-description">
                Deploy comprehensive security questionnaires covering data
                protection, incident response, business continuity, and
                compliance. Validate responses with supporting evidence and
                documentation.
              </p>
            </div>
            <div className="process-vrm-one__step">
              <div className="process-vrm-one__step-number">
                <span>03</span>
              </div>
              <div className="process-vrm-one__step-icon">
                <svg
                  width="32"
                  xmlns="http://www.w3.org/2000/svg"
                  height="32"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2M16 3.128a4 4 0 0 1 0 7.744M22 21v-2a4 4 0 0 0-3-3.87"></path>
                    <circle r="4" cx="9" cy="7"></circle>
                  </g>
                </svg>
              </div>
              <h3 className="process-vrm-one__step-title">
                Vendor Segmentation
              </h3>
              <p className="section-content process-vrm-one__step-description">
                Group vendors by risk profile, business function, and regulatory
                requirements. Apply differentiated monitoring frequencies and
                control requirements based on risk tier.
              </p>
            </div>
          </div>
        </div>
      </section>
      <section className="process-vrm-two">
        <div className="process-vrm-two__container">
          <div className="process-vrm-two__header">
            <h2 className="process-vrm-two__section-title section-title">
              Third-Party Risk Scoring Methodology
            </h2>
            <p className="section-subtitle process-vrm-two__section-subtitle">
              Our proprietary approach to quantifying vendor risk through
              systematic data collection, validation, and scoring.
            </p>
          </div>
          <div className="process-vrm-two__steps">
            <div className="process-vrm-two__step">
              <div className="process-vrm-two__step-number">
                <span>01</span>
              </div>
              <div className="process-vrm-two__step-icon">
                <svg
                  width="32"
                  xmlns="http://www.w3.org/2000/svg"
                  height="32"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <circle r="8" cx="11" cy="11"></circle>
                    <path d="m21 21l-4.34-4.34"></path>
                  </g>
                </svg>
              </div>
              <h3 className="process-vrm-two__step-title">Data Collection</h3>
              <p className="section-content process-vrm-two__step-description">
                Gather comprehensive information through standardized
                questionnaires, certification reviews, security documentation
                analysis, and direct vendor interviews.
              </p>
            </div>
            <div className="process-vrm-two__step">
              <div className="process-vrm-two__step-number">
                <span>02</span>
              </div>
              <div className="process-vrm-two__step-icon">
                <svg
                  width="32"
                  xmlns="http://www.w3.org/2000/svg"
                  height="32"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M22 12h-2.48a2 2 0 0 0-1.93 1.46l-2.35 8.36a.25.25 0 0 1-.48 0L9.24 2.18a.25.25 0 0 0-.48 0l-2.35 8.36A2 2 0 0 1 4.49 12H2"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
              </div>
              <h3 className="process-vrm-two__step-title">Risk Scoring</h3>
              <p className="section-content process-vrm-two__step-description">
                Apply weighted scoring algorithms across security controls,
                compliance posture, financial stability, and operational
                resilience to produce quantitative risk ratings.
              </p>
            </div>
            <div className="process-vrm-two__step">
              <div className="process-vrm-two__step-number">
                <span>03</span>
              </div>
              <div className="process-vrm-two__step-icon">
                <svg
                  width="32"
                  xmlns="http://www.w3.org/2000/svg"
                  height="32"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M6 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2z"></path>
                    <path d="M14 2v5a1 1 0 0 0 1 1h5M9 15l2 2l4-4"></path>
                  </g>
                </svg>
              </div>
              <h3 className="process-vrm-two__step-title">Verification</h3>
              <p className="section-content process-vrm-two__step-description">
                Validate vendor claims through independent evidence review,
                audit report analysis, and third-party attestation verification
                to ensure accuracy and completeness.
              </p>
            </div>
          </div>
        </div>
      </section>
      <section className="stats-vrm">
        <div className="stats-vrm__container">
          <div className="stats-vrm__header">
            <h2 className="stats-vrm__section-title section-title">
              Continuous Monitoring &amp; Remediation
            </h2>
            <p className="section-subtitle stats-vrm__section-subtitle">
              Real-time vendor oversight with automated risk flags, incident
              tracking, and remediation workflows to maintain supply chain
              security.
            </p>
          </div>
          <div className="stats-vrm__grid">
            <div className="stats-vrm__card">
              <div className="stats-vrm__card-icon">
                <svg
                  width="40"
                  xmlns="http://www.w3.org/2000/svg"
                  height="40"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M22 12h-2.48a2 2 0 0 0-1.93 1.46l-2.35 8.36a.25.25 0 0 1-.48 0L9.24 2.18a.25.25 0 0 0-.48 0l-2.35 8.36A2 2 0 0 1 4.49 12H2"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
              </div>
              <div className="stats-vrm__card-content">
                <div className="stats-vrm__card-value">
                  <span>24/7</span>
                </div>
                <h3 className="stats-vrm__card-label">Live Monitoring</h3>
                <p className="section-content stats-vrm__card-description">
                  Continuous automated surveillance of vendor security posture,
                  compliance status, and cyber threat intelligence.
                </p>
              </div>
            </div>
            <div className="stats-vrm__card">
              <div className="stats-vrm__card-icon">
                <svg
                  width="40"
                  xmlns="http://www.w3.org/2000/svg"
                  height="40"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <circle r="10" cx="12" cy="12"></circle>
                    <path d="M12 8v4m0 4h.01"></path>
                  </g>
                </svg>
              </div>
              <div className="stats-vrm__card-content">
                <div className="stats-vrm__card-value">
                  <span>Instant</span>
                </div>
                <h3 className="stats-vrm__card-label">Risk Flags</h3>
                <p className="section-content stats-vrm__card-description">
                  Immediate alerts triggered by security incidents, compliance
                  violations, or significant vendor status changes.
                </p>
              </div>
            </div>
            <div className="stats-vrm__card">
              <div className="stats-vrm__card-icon">
                <svg
                  width="40"
                  xmlns="http://www.w3.org/2000/svg"
                  height="40"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M20 6L9 17l-5-5"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
              </div>
              <div className="stats-vrm__card-content">
                <div className="stats-vrm__card-value">
                  <span>Automated</span>
                </div>
                <h3 className="stats-vrm__card-label">Remediation Tracking</h3>
                <p className="section-content stats-vrm__card-description">
                  Structured workflows for issue assignment, progress
                  monitoring, and closure verification with SLA enforcement.
                </p>
              </div>
            </div>
            <div className="stats-vrm__card">
              <div className="stats-vrm__card-icon">
                <svg
                  width="40"
                  xmlns="http://www.w3.org/2000/svg"
                  height="40"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M2.062 12.348a1 1 0 0 1 0-.696a10.75 10.75 0 0 1 19.876 0a1 1 0 0 1 0 .696a10.75 10.75 0 0 1-19.876 0"></path>
                    <circle r="3" cx="12" cy="12"></circle>
                  </g>
                </svg>
              </div>
              <div className="stats-vrm__card-content">
                <div className="stats-vrm__card-value">
                  <span>360°</span>
                </div>
                <h3 className="stats-vrm__card-label">Visibility Dashboard</h3>
                <p className="section-content stats-vrm__card-description">
                  Executive dashboards providing real-time vendor risk metrics,
                  trend analysis, and compliance reporting.
                </p>
              </div>
            </div>
            <div className="stats-vrm__card">
              <div className="stats-vrm__card-icon">
                <svg
                  width="40"
                  xmlns="http://www.w3.org/2000/svg"
                  height="40"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
              </div>
              <div className="stats-vrm__card-content">
                <div className="stats-vrm__card-value">
                  <span>Quarterly</span>
                </div>
                <h3 className="stats-vrm__card-label">Review Cycles</h3>
                <p className="section-content stats-vrm__card-description">
                  Regular reassessment schedules tailored to vendor risk tier,
                  ensuring current risk profiles and compliance status.
                </p>
              </div>
            </div>
            <div className="stats-vrm__card">
              <div className="stats-vrm__card-icon">
                <svg
                  width="40"
                  xmlns="http://www.w3.org/2000/svg"
                  height="40"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"></path>
                    <path d="m9 12l2 2l4-4"></path>
                  </g>
                </svg>
              </div>
              <div className="stats-vrm__card-content">
                <div className="stats-vrm__card-value">
                  <span>Complete</span>
                </div>
                <h3 className="stats-vrm__card-label">Audit Trail</h3>
                <p className="section-content stats-vrm__card-description">
                  Comprehensive documentation of all vendor assessments,
                  findings, and remediation activities for compliance and audit
                  purposes.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="compliance-vrm">
        <div className="compliance-vrm__container">
          <div className="compliance-vrm__header">
            <h2 className="compliance-vrm__section-title section-title">
              Compliance Framework Alignment
            </h2>
            <p className="section-subtitle compliance-vrm__section-subtitle">
              Our vendor risk management program aligns with global regulatory
              standards and industry frameworks to ensure comprehensive
              compliance coverage.
            </p>
          </div>
          <div className="compliance-vrm__grid">
            <div className="compliance-vrm__card">
              <div className="compliance-vrm__card-icon">
                <svg
                  width="48"
                  xmlns="http://www.w3.org/2000/svg"
                  height="48"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"></path>
                    <path d="m9 12l2 2l4-4"></path>
                  </g>
                </svg>
              </div>
              <h3 className="compliance-vrm__card-title">ISO Standards</h3>
              <p className="section-content compliance-vrm__card-description">
                Full alignment with ISO 27001 information security management,
                ISO 27002 controls, and ISO 31000 risk management frameworks for
                comprehensive vendor oversight.
              </p>
            </div>
            <div className="compliance-vrm__card">
              <div className="compliance-vrm__card-icon">
                <svg
                  width="48"
                  xmlns="http://www.w3.org/2000/svg"
                  height="48"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
              </div>
              <h3 className="compliance-vrm__card-title">SOC Compliance</h3>
              <p className="section-content compliance-vrm__card-description">
                Integration with SOC 2 Type II requirements, ensuring vendor
                controls meet security, availability, processing integrity,
                confidentiality, and privacy principles.
              </p>
            </div>
            <div className="compliance-vrm__card">
              <div className="compliance-vrm__card-icon">
                <svg
                  width="48"
                  xmlns="http://www.w3.org/2000/svg"
                  height="48"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M20 6L9 17l-5-5"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
              </div>
              <h3 className="compliance-vrm__card-title">PCI-DSS</h3>
              <p className="section-content compliance-vrm__card-description">
                Vendor assessments mapped to Payment Card Industry Data Security
                Standards, critical for third parties processing, storing, or
                transmitting cardholder data.
              </p>
            </div>
            <div className="compliance-vrm__card">
              <div className="compliance-vrm__card-icon">
                <svg
                  width="48"
                  xmlns="http://www.w3.org/2000/svg"
                  height="48"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <circle r="10" cx="12" cy="12"></circle>
                    <path d="M12 2a14.5 14.5 0 0 0 0 20a14.5 14.5 0 0 0 0-20M2 12h20"></path>
                  </g>
                </svg>
              </div>
              <h3 className="compliance-vrm__card-title">GDPR</h3>
              <p className="section-content compliance-vrm__card-description">
                Comprehensive data protection and privacy assessments aligned
                with General Data Protection Regulation requirements for vendor
                data processing activities.
              </p>
            </div>
            <div className="compliance-vrm__card">
              <div className="compliance-vrm__card-icon">
                <svg
                  width="48"
                  xmlns="http://www.w3.org/2000/svg"
                  height="48"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2M16 3.128a4 4 0 0 1 0 7.744M22 21v-2a4 4 0 0 0-3-3.87"></path>
                    <circle r="4" cx="9" cy="7"></circle>
                  </g>
                </svg>
              </div>
              <h3 className="compliance-vrm__card-title">CCPA</h3>
              <p className="section-content compliance-vrm__card-description">
                California Consumer Privacy Act compliance validation for
                vendors handling consumer personal information, including data
                rights and disclosure obligations.
              </p>
            </div>
            <div className="compliance-vrm__card">
              <div className="compliance-vrm__card-icon">
                <svg
                  width="48"
                  xmlns="http://www.w3.org/2000/svg"
                  height="48"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <circle r="8" cx="11" cy="11"></circle>
                    <path d="m21 21l-4.34-4.34"></path>
                  </g>
                </svg>
              </div>
              <h3 className="compliance-vrm__card-title">Industry-Specific</h3>
              <p className="section-content compliance-vrm__card-description">
                Tailored assessments for sector-specific regulations including
                HIPAA for healthcare, GLBA for financial services, and ITAR for
                defense contractors.
              </p>
            </div>
          </div>
        </div>
      </section>
      <section className="vendor-risk-management-thq-cta-vrm-elm cta-vrm">
        <div className="cta-vrm__container">
          <div className="cta-vrm__column">
            <div className="cta-vrm__content">
              <h2 className="section-title cta-vrm__title">
                Request a Vendor Risk Assessment
              </h2>
              <p className="section-content cta-vrm__description">
                Start with a complimentary consultation to evaluate your current
                vendor risk posture and identify opportunities for supply chain
                security improvement.
              </p>
              <a href="/contact-us">
                <div className="vendor-risk-management-thq-btn-elm3 btn-xl btn-accent btn cta-vrm__button">
                  <span>Request Assessment</span>
                </div>
              </a>
            </div>
          </div>
        </div>
      </section>
      <div className="vendor-risk-management-container2">
        <div className="vendor-risk-management-container3">
          <Script
            html={`<style>
        @keyframes fadeIn {from {opacity: 0;
transform: translateY(-8px);}
to {opacity: 1;
transform: translateY(0);}}
        </style> `}
          ></Script>
        </div>
      </div>
      <div className="vendor-risk-management-container4">
        <div className="vendor-risk-management-container5">
          <Script
            html={`<script defer data-name="faq-accordion-animation">
(function(){
  const faqItems = document.querySelectorAll(".faq-vrm__item")

  faqItems.forEach((item) => {
    const summary = item.querySelector(".faq-vrm__question")

    summary.addEventListener("click", () => {
      faqItems.forEach((otherItem) => {
        if (otherItem !== item && otherItem.hasAttribute("open")) {
          otherItem.removeAttribute("open")
        }
      })
    })
  })
})()
</script>`}
          ></Script>
        </div>
      </div>
      <Footer></Footer>
    </div>
  )
}

export default VendorRiskManagement
